import * as CONST from '../util/app-constants';

const initalState = {
    deviceId: CONST.INITIAL_DEVICE_ID,
    // temperatureThreshold: CONST.TEMPERATURE_THRESHOLD,
    // spatialDepthThreshold: CONST.SPATIAL_DEPTH_THRESHOLD,
    // humidityThreshold: CONST.HUMIDITY_THRESHOLD,
    // powerLeakageThreshold: CONST.POWER_LEAKAGE_THRESHOLD,
    // gasLeakageThreshold: CONST.GAS_LEAKAGE_THRESHOLD,
    // batteryChargeThreshold: CONST.BATTERY_CHARGE_THRESHOLD,
    // waterTimeThreshold: CONST.WATER_TIME_THRESHOLD,
    // gasTimeThreshold: CONST.GAS_TIME_THRESHOLD,
    // powerVoltThreshold: CONST.POWER_VOLT_THRESHOLD,
    // intrusionThreshold: CONST.INTRUSION_THRESHOLD,
    thresholds: CONST.THRESHOLDS,
    isLoaderShown: false,
    linkToLogo: null,
    linkOfLogo: null,
    payload: null,
    notificationPageTimestampOfElementToHighlight: null,
    notificationDeviceId: null,
    notificationTimestamp: null,
    deviceCatalogue: {
        data: [],
        pageNumber: 0,
    },
    deviceCatalogueFilter: {
        data: [],
        pageNumber: 0,
    },
    nodeVitals: {
        data: [],
        pageNumber: 0,
    },
    nodeVitalsFilter: {
        data: [],
        pageNumber: 0,
    },
    nodeVitalFilter: [],
    deviceCatalogueFilters: [],
    dataExtract: {
        data: [],
        pageNumber: 0,
    },
    alertModification: {
        data: [],
        pageNumber: 0,
    },
    alertModificationFilter: {
        data: [],
        pageNumber: 0,    
    },
    alertFilter: [],
};

const symbioticReducer = (state = initalState, action) => {
    switch (action.type) {
        case 'UPDATE_DEVICE_ID':
            return {
                ...state,
                deviceId: action.deviceId,
            };
        case 'DEVICE_CATELOGUE_DATA':
            return {
                ...state,
                deviceCatalogue: action.deviceCatalogue,
            };
        case 'DEVICE_CATELOGUE_FILTER_DATA':
            return {
                ...state,
                deviceCatalogueFilter: action.deviceCatalogueFilter,
            };
        case 'NODE_VITALS_DATA':
            return {
                ...state,
                nodeVitals: action.nodeVitals,
            };
        case 'NODE_VITALS_FILTER_DATA':
            return {
                ...state,
                nodeVitalsFilter: action.nodeVitalsFilter,
            };
        case 'NODE_VITALS_FILTER':
            return {
                ...state,
                nodeVitalFilter: action.nodeVitalFilter,
            };
        case 'DEVICE_CATALOGUE_FILTER':
            return {
                ...state,
                deviceCatalogueFilters: action.deviceCatalogueFilters,
            };
        case 'EXTRACT_DATA':
            return {
                ...state,
                dataExtract: action.dataExtract,
            };
        case 'ALERT_MODIFICATION_DATA':
            return {
                ...state,
                alertModification: action.alertModification,
            };
        case 'ALERT_MODIFICATION_FILTER_DATA':
            return {
                ...state,
                alertModificationFilter: action.alertModification,
            };
        case 'ALERT_FILTER':
            return {
                ...state,
                alertFilter: action.alertFilter,
            };
        case 'UPDATE_THRESHOLDS':
            const thresholds = action.data.slice();
            return {
                ...state,
                thresholds: {
                    ...state.thresholds,
                    ...thresholds[0]
                }
                // temperatureThreshold: thresholds[0].thresholdTemperatureValue,
                // spatialDepthThreshold: thresholds[0].thresholdSpatialValue,
                // humidityThreshold: thresholds[0].thresholdHumidityValue,
                // powerLeakageThreshold: thresholds[0].thresholdPowerValue,
                // gasLeakageThreshold: thresholds[0].thresholdGasValue,
                // batteryChargeThreshold: thresholds[0].thresholdBatteryValue,
                // waterTimeThreshold: thresholds[0].thresholdWaterTime,
                // gasTimeThreshold: thresholds[0].thresholdGasTime,
                // powerVoltThreshold: thresholds[0].thresholdPowerVolt,
                // intrusionThreshold: thresholds[0].thresholdIntrusionValue,
            };
        case 'CHANGE_HEARTBEAT_LAYOUT':
            return {
                ...state,
                layoutHeartbeat: action.layout,
            };
        case 'CHANGE_HEARTBEAT_MA':
            return {
                ...state,
                isMARight: action.isRight,
            };
        case 'SHOW_OVERALL_APP_LOADER':
            return {
                ...state,
                isLoaderShown: true
            };
        case 'HIDE_OVERALL_APP_LOADER':
            return {
                ...state,
                isLoaderShown: false
            };
        case 'UPDATE_LOGO_AND_LINK':
            return {
                ...state,
                linkToLogo: action.payload.linkToLogo,
                linkOfLogo: action.payload.linkOfLogo
            };
        case 'SIGN_OUT':
            return { ...initalState };
        case 'DEVICE_PAYLOAD':
            return {
                ...state,
                payload: action.payload
            };
        case 'UPDATE_DEVICE_ID_AND_TIMESTAMP':
            return {
                ...state,
                deviceId: action.deviceId,
                notificationPageTimestampOfElementToHighlight: action.notificationPageTimestampOfElementToHighlight
            };
        case 'MANUAL_CLEAR_CLICKED':
            return {
                ...state,
                notificationDeviceId: action.notificationDeviceId,
                notificationTimestamp: action.notificationTimestamp
            };
        default:
            return state;
    }
};

export default symbioticReducer;


// WEBPACK FOOTER //
// ./reducers/SymbioticReducer.js